define('vspot-validation',['jquery', 'angular', 'localize', 'angular-messages', 'vspot'], function($, ng) {
    'use strict';
    /*
     *  This is an attempt to write a unifying form validation handler that follows
     *  SignUp.com standards, and includes our localization.
     *
     *  NOTE: Any input that you want validated is required to have the name attribute defined.
     *
     *  Parameters:
     *      vspot-validation: {required} The form action to run when the form passes validation.
     *      name: {required} Angular uses the name of the form to publish under $scope.
     *      role: {optional} Helps screen readers. The directive adds it for you.
     *      accept-charset: {optional} Makes sure the browser sends data correctly. The directive
     *          adds it for you if missing, and makes sure it's set to "utf-8" if not.
     *      novalidate: {optional} Makes sure the browser doesn't try to do the job of this
     *          directive. The directive adds it for you.
     */

     var validation = ng.module('vspot.validation', ['localization', 'ngMessages', 'vspot']);

     validation.service('validation-helper', ['$log', function($log) {
        /*
         * checkFroala:
         *  Check a Froala field to see if it's in code view, and switch it back
         *  if it is. Should be called before submit so that Froala will update
         *  it's model with the changes from code view.
         *
         *  Params:
         *      elem:           {required} - Either a jQuery object or an ID for the Froala editor to check
         *      debug:          {optional} - should we be logging what we're doing here?
         *      debugPrefix:    {optional} - when logging debugging data, what should we prefix it with?
         */
        this.checkFroala = function(elem, debug, debugPrefix) {
            if( debug === undefined ) {
                debug = false;
            } else if( debugPrefix === undefined ) {
                debugPrefix = '';
            }
            var toCheck;
            if( typeof( elem.is ) === "function" ) {
                // We have a jquery object already
                toCheck = elem;
            } else {
                // We should have been sent an id
                if( elem.substring(0, 1) !== '#' ) {
                    elem = '#' + elem;
                }

                toCheck = $(elem);
            }

            if( toCheck.froalaEditor('codeView.isActive') ) {
                if(debug) $log.log(debugPrefix + 'Found a Froala editor, that is in code view. Setting back to design view:', elem);
                toCheck.froalaEditor('codeView.toggle');
            } else {
                if(debug) $log.log(debugPrefix + 'Found a Froala editor, but it is not in code view:', elem);
            }
        };
     }]);
     
     validation.directive('vspotValidation', ['$document', '$log', '$timeout', 'localize', '$parse', '$filter', '$compile', 'validation-helper', function ($document, $log, $timeout, localize, $parse, $filter, $compile, validationHelper) {
        return {
            restrict:   'A', // Attribute only
            scope:      false, // Share the scope the directive is included in
            link:       function (scope, elem, attrs) {
                var localData = {
                    form:                   null,   // the Angular form reference in the scope.
                    formDom:                elem,   // the DOM element of the form.
                    action:                 null,   // Where to submit to
                    formFieldFocused:       false,  // tracks if we focused on a field yet when setting all fields dirty.
                    localizationLoaded:     false,  // tracks if the localization resource file has loaded.
                    formBuilt:              false,  // tracks if the form has finished building (just lets a digest cycle run once).
                    debug:                  false,  // tracks if we are displaying debugging data?
                    debugPrefix:            '',     // the debugging prefix to print to the console (helpful if multiple forms on the same page).
                    lastSubmitTime:         null    // the time the form was last submitted
                };

                var dateTimeTypes   = ['date', 'datetime-local', 'month', 'time', 'week']; // See Angular site for supported types
                var simpleTypes     = ['text', 'password', 'checkbox', 'radio']; // These types don't need extra validation (i.e. if you can type it, it's text or a password, and radio and checkbox don't have special validation)
                /* For a little more explanation on "simpleTypes", they are fields that don't need anything extra.
                 * For example, email is not a simple time. It's a text field, that has extra processing to enforce
                 * that the text entered is in fact an email. Similarly, the number type is valided text, but it's
                 * got to be text that is actually numeric. These have built-in extra Angular processing. Simple types don't.
                 */

                // debug - If present we tell the developer what's going on.
                // Todo: think about logging levels
                if( attrs.debug !== undefined ) {
                    localData.debug = true;
                    if(localData.debug) $log.log('validation initialized.', scope, elem, attrs);
                }

                // Check required elements:
                if( global_helper.blank( attrs.name ) ) {
                    elem.addClass('validation-failed');
                    $log.error('Missing form attribute: "name". Validation directive unable to proceed. Adding class "validation-failed" to form so it\'s easier to find. Exiting...');
                    return false;
                } else {
                    // Get the form from the scope for easy reference
                    localData.form = scope.$eval(attrs.name);
                    
                    if( global_helper.blank( localData.form ) ) {
                        elem.addClass('validation-failed');
                        $log.error('Invalid form name: "' + attrs.name + '". Unable to find in scope. Validation directive unable to proceed. Adding class "validation-failed" to form so it\'s easier to find. Exiting...');
                        return false;
                    }

                    // Now that we have a name... Note if debugging:
                    localData.debugPrefix = '----------[ ' + attrs.name + ': ';
                    if(localData.debug) $log.log(localData.debugPrefix + ' Debugging on.');
                }

                // Where does this from submit to?
                if( global_helper.blank( attrs.vspotValidation ) ) {
                    if(localData.debug) $log.log(localData.debugPrefix + 'No validation function, the form will submit normally.');
                    localData.action = true;
                } else {
                    if(localData.debug) $log.log(localData.debugPrefix + 'We have a validation function: ' + attrs.vspotValidation);

                    // Now, can we find it?
                    // But is it in this scope or the parent scope?
                    localData.action = scope.$eval(attrs.vspotValidation);

                    if( global_helper.blank( localData.action ) ) {
                        if(localData.debug) $log.log(localData.debugPrefix + "Trying to find function '" + attrs.vspotValidation + "' in the current scope failed. Looking in the parent scope.");

                        localData.action = scope.$parent.$eval(attrs.vspotValidation);
                        if( global_helper.blank( localData.action ) ) {
                            $log.error("Trying to find function '" + attrs.vspotValidation + "' in the current and parent scopes failed.");
                            return false;
                        } else {
                            if(localData.debug) $log.log(localData.debugPrefix + "Found function '" + attrs.vspotValidation + "' in the parent scope.");
                        }

                    } else {
                        if(localData.debug) $log.log(localData.debugPrefix + "Found function '" + attrs.vspotValidation + "' in the current scope.");
                    }
                }

                // Check things we can fix:
                var isForm = false; // Is it an actual form tag?
                if( localData.formDom.prop('tagName').toLowerCase() === 'form' ) {
                    isForm = true;
                }
                /* method="post" - to make sure we don't submit by get accidentally unless we really, really want to.
                 * This is an attempt to keep PII from leaking to third party advertisers via a form submitting to
                 * itself and putting GET data in the URL.
                 */
                if( isForm && global_helper.blank( attrs.method ) ) {
                    $log.info('Missing form attribute: "method". Adding \'method="post"\' in case a user submits the form before JS submit method attaches.');
                    elem.attr('method', 'post');
                }
                // role="form" - for screen readers
                if( isForm && global_helper.blank( attrs.role ) ) {
                    $log.info('Missing form attribute: "role". Adding \'role="form"\' to assist with screen readers.');
                    elem.attr('role', 'form');
                }
                // accept-charset for utf-8 data
                if( isForm && global_helper.blank( attrs.acceptCharset ) ) {
                    $log.info('Missing form attribute: "accept-charset". Adding \'accept-charset="utf-8"\' to make sure the browser sends data correctly.');
                    elem.attr('accept-charset', 'utf-8');
                } else if( isForm && attrs.acceptCharset.toLowerCase() !== 'utf-8' ) {
                    $log.info('Improper form attribute: "accept-charset". Change to \'accept-charset="utf-8"\' to make sure the browser sends data correctly.');
                    elem.attr('accept-charset', 'utf-8');
                }
                // novalidate - To turn off HTML5 validation so we can use our own
                if( isForm && attrs.novalidate === undefined ) { // <-- Don't use global_helper.blank here, because it will be an empty string which counts as blank
                    $log.info('Missing form attribute: "novalidate". Adding \'novalidate\' stop the browser from doing the validation itself.');
                    elem.attr('novalidate', '');
                }

                /* setUpMessages:
                 *  Add error messages to fields.
                 *  @param {obj} myForm - the form (or subform) to operate on.
                 */
                var setUpMessages = function(myForm) {
                    // Mark it as done so we only do it once
                    if( localData.errorLabelsAdded ) {
                        return;
                    }

                    localData.errorLabelsAdded = true;
                    var field, fieldName, skip, insertAfter, classes, forId, tmp, elemStr, messageKeys, key, k, kLen, extra, filterTmp, filterP1, filterP2, errorStr, fieldBaseName;

                    // Iterate over the form to find fields needing error labels
                    ng.forEach(myForm, function(field, fieldName) {
                        if( fieldName.indexOf('$') !== 0 ) {
                            // It's not an internal Angular attribute, so add it
                            if( global_helper.blank( field.$addControl ) && !global_helper.blank( field.$validators ) ) {
                                var formElem = $('[name="' + field.$name + '"]:first', localData.formDom); // :first in the case of radio buttons with the same name
                                if( formElem.length ) {
                                    // Should we skip this field?
                                    skip = formElem.attr('validation-skip');
                                    if( skip === 'true' ) {
                                        if(localData.debug) $log.log(localData.debugPrefix + 'Skipping validation for ' + field.$name);
                                    } else {
                                        // We have an element to check
                                        if(localData.debug) $log.log(localData.debugPrefix + 'Adding validation for ' + field.$name);

                                        // Check for element to put the error messages after
                                        tmp = formElem.attr('validation-after');
                                        insertAfter = formElem; // Default is to stick the error labels after the form element
                                        if( tmp ) {
                                            insertAfter = $('#' + tmp, localData.formDom);
                                        }

                                        // Check to see if the errors need a different CSS class
                                        tmp = formElem.attr('validation-classes');
                                        classes = 'ng-hide'; // Set the default
                                        if( tmp ) {
                                            classes += ' ' + tmp;
                                        }

                                        // Make sure it has an ID
                                        forId = false;
                                        tmp = formElem.attr('id');
                                        if( tmp ) {
                                            forId = tmp;
                                        } else {
                                            forId = field.$name + '-' + 'validation-assigned-id';
                                            formElem.attr('id', forId);
                                            if(localData.debug) $log.log(localData.debugPrefix + field.$name + ' has no id, assigning one: ' + forId);
                                        }
                                        
                                        // On focus, make sure the element's error labels aren't shown
                                        formElem.on('focus', {focusId: forId, focusField: field}, function(event) {
                                            if(localData.debug) $log.log(localData.debugPrefix + event.data.focusId + ' Focused.');
                                            $timeout(function(f) {
                                                f.focused = true;
                                            }, 0, true, event.data.focusField);
                                        });

                                        // On blur, allow the element's error labels to show
                                        formElem.on('blur', {blurId: forId, blurField: field}, function(event) {
                                            if(localData.debug) $log.log(localData.debugPrefix + event.data.blurId + ' Blurred.');
                                            $timeout(function(f) {
                                                f.focused   = false;
                                                f.showError = false;
                                            }, 0, true, event.data.blurField);
                                        });

                                        // What messages should we build?
                                        messageKeys = [];
                                        ng.forEach(field.$validators, function(v, k) {
                                            messageKeys.push(k);
                                        });
                                        
                                        // Some types aren't in the $validators array, but we want to make sure it's not in messageKeys already, just in case this isn't always true in the future.
                                        if( messageKeys.indexOf( formElem.attr('type') ) === -1 && formElem.attr('type') !== undefined ) {
                                            if( dateTimeTypes.indexOf( formElem.attr('type') ) !== -1 ) {
                                                // Invalid date/time types don't show in $validators, so we need to manually add the message.
                                                messageKeys.push( formElem.attr('type') );
                                                if(localData.debug) $log.log(localData.debugPrefix + forId + ': Adding validation for this type: ' + formElem.attr('type'));
                                            } else if( simpleTypes.indexOf( formElem.attr('type') ) !== -1 ) {
                                                // This is a skippable type.
                                                // Pass...
                                            } else if( formElem.attr('type') === 'number' ) {
                                                // number doesn't show up in the $validators, so we need to manually add the message.
                                                messageKeys.push( formElem.attr('type') );
                                                if(localData.debug) $log.log(localData.debugPrefix + forId + ': Adding validation for this type: ' + formElem.attr('type'));
                                            } else {
                                                // Something unexpected
                                                if(localData.debug) $log.log(localData.debugPrefix + forId + ': No validation specified for this type: ' + formElem.attr('type'));
                                            }
                                        }

                                        // Build the messages array
                                        field.messages = {};
                                        
                                        for( k=0, kLen=messageKeys.length; k<kLen; k++ ) {
                                            key         = messageKeys[k];
                                            extra       = [];
                                            tmp         = formElem.attr(key);
                                            filterTmp   = formElem.attr('validation-' + key + '-filter'); // Are we applying a filter?
                                            filterP1    = formElem.attr('validation-' + key + '-filter-param1'); // Are we sending a param to the filter?
                                            filterP2    = formElem.attr('validation-' + key + '-filter-param2'); // Are we sending a second param to the filter?


                                            // Special handler for min and max on date fields.
                                            // NOTE: should probably apply to datetime-local, month, time, and week types as well.
                                            if( (key === 'min' || key === 'max') && formElem.attr('type') === 'date' ) {
                                                if( !filterTmp ) {
                                                    filterTmp = 'date';

                                                    if( !filterP1 ) {
                                                        filterP1 = 'mediumDate';
                                                    }
                                                }
                                            }

                                            if( !tmp ) {
                                                // Look for the angular version of the key
                                                tmp = formElem.attr('ng-' + key);
                                            }

                                            if( tmp ) {
                                                if( filterTmp ) {
                                                    // Run the temp value through the filter first
                                                    // extra.push( applyFilter( tmp, filterTmp, filterP1, filterP2 ) );
                                                    extra.push( $filter(filterTmp)(tmp, filterP1, filterP2) );
                                                } else {
                                                    // Just add the temp value to the extra array
                                                    extra.push(tmp);
                                                }
                                            }

                                            errorStr = formElem.attr('validation-' + key);
                                            if( global_helper.blank(errorStr) ) {
                                                // Use the default
                                                errorStr = '_VALIDATION_' + key.toUpperCase() + '_ERROR_';

                                                // Special handler for min and max on date/time fields.
                                                if( (key === 'min' || key === 'max') && dateTimeTypes.indexOf( formElem.attr('type') ) !== -1 ) {
                                                    errorStr = '_VALIDATION_' + formElem.attr('type').toUpperCase() + '_' + key.toUpperCase() + '_ERROR_';
                                                }
                                            }

                                            field.messages[key] = localize.getLocalizedString(errorStr, extra);
                                        }

                                        fieldBaseName = attrs.name + '.' + field.$name;
                                        if( formElem.is(':checkbox') || formElem.is(':radio') ) {
                                            /* No focus to contend with... this is a little tricky. We do have the focus
                                             * and blur events above, which we need for the $timeouts to run to let the
                                             * UI know that something happened and they need to update the display. But,
                                             * we don't actually want to worry about whether or not the user is focused
                                             * on the element, because it's tiny and they tend to interact more with the
                                             * label.
                                             */
                                            elemStr =   '<div class="' + classes + '" ng-messages="' + fieldBaseName + '.$error" role="alert" ng-show="' + attrs.name + '.$submitted">';
                                        } else {
                                            // Take focus into account
                                            elemStr =   '<div class="' + classes + ' ' + field.$name + '_error' + '" ng-messages="' + fieldBaseName + '.$error" role="alert" ng-show="' + attrs.name + '.$submitted && (!' + fieldBaseName + '.focused || ( ' + fieldBaseName + '.focused && ' + fieldBaseName + '.showError ) )">';
                                        }
                                        elemStr +=      '<div ng-repeat="(key, message) in ' + fieldBaseName + '.messages">';
                                        elemStr +=          '<label for="' + forId + '" ng-message-exp="key" class="text-danger">{{message}}</label>';
                                        elemStr +=      '</div>';
                                        elemStr +=  '</div>';
                                        insertAfter.after( $compile(elemStr)(scope) );
                                    }
                                }
                            }
                        }
                    });
                };

                /*
                 * NOTE: We have 2 checks below. One is to make sure the localization resource has loaded.
                 * The second is to make sure the form is built. Each event happens and sets it flag to
                 * true. Whichever one runs second will see that both are true and run setUpMessages().
                 */
                // We need to make sure the localization data has loaded
                if( localize.resourceFileLoaded ) {
                    // Already loaded!
                    localData.localizationLoaded = true;
                    if( !localData.errorLabelsAdded && localData.formBuilt ) {
                        // We are clear to add the error labels
                        setUpMessages(localData.form);
                    }
                } else {
                    // Wait until it reports that it's loaded
                    scope.$on('localizeResourcesUpdated', function () {
                        localData.localizationLoaded = true;
                        if( !localData.errorLabelsAdded && localData.formBuilt ) {
                            // We are clear to add the error labels
                            setUpMessages(localData.form);
                        }
                    });
                }

                // We are waiting on a timeout to occur, which means a digest cycle has happened and the form exists.
                $timeout(function() {
                    localData.formBuilt = true;
                    if( !localData.errorLabelsAdded && localData.localizationLoaded ) {
                        // We are clear to add the error labels
                        setUpMessages(localData.form);
                    }
                });

                /*
                 * focusOther:
                 *      Loop over the form and find the other field to focus on.
                 *      Recurses into sub-forms.
                 *
                 *      @param elem - either the form, sub-form, or an individual element. This is the thing with the error state attached to it.
                 *      @param otherElem - The id OR the jQeury object we want to focus on.
                 */
                var focusOther = function(elem, otherElem) {
                    if( otherElem instanceof jQuery ) {
                        elem.showError = true;
                        otherElem.focus();
                    } else if( elem.$setTouched === undefined ) {
                        // Find the field to focus on
                        ng.forEach(elem, function(element, key) {
                            if( key.indexOf('$') !== 0 && !global_helper.blank(element) ) {
                                //  It's not an internal Angular attribute, so focus on it.
                                focusOther(element, otherElem);
                            }
                        });
                    } else {
                        var formElem = $('[name="' + elem.$name + '"]:first', localData.formDom); // need :first in the case of radio buttons with the same name
                        if( formElem.attr('id') === otherElem ) {
                            // Found it!
                            elem.showError = true;
                            formElem.focus();
                        }
                    }
                };

                /*
                 * setAllDirty:
                 *      Iterate over the form and set all the fields to dirty.
                 *      Recurses into sub-forms.
                 */
                var setAllDirty = function(shouldWeFocus) {
                    if(localData.debug) $log.log(localData.debugPrefix + 'setAllDirty called.', elem);
                    localData.formFieldFocused  = false;
                    var focusFirstError         = false;
                    var focusFirst              = false;
                    var tmpField, otherField, tmp, tmpFroala;

                    if( shouldWeFocus ) {
                        /* Focus on the first field by default.
                         * NOTE: This is not doing the actual focusing. We are merely
                         * estabishing that there is a field to focus on. If not, then
                         * we have the opportunity to show the user an error below.
                         * This is a fair amount of code to cover the case of forms not
                         * submitting when they are in an error state, but the acutal
                         * error field is hidden. Perhaps there's a better way...
                         */
                        focusFirst          = true;
                        var fields          = localData.formDom.find('input,textarea,select,[class^="uib-"]').not(':submit');
                        var firstErrorField = false;
                        var errorFields     = fields.filter('.ng-invalid'); //.filter(':visible:first');

                        for( var e=0, eLen=errorFields.length; e<eLen; e++ ) {
                            // Check that it's visible
                            tmpField = $(errorFields[e]);
                            if( tmpField.is(':visible') ) {
                                firstErrorField = errorFields[e];
                                break;
                            } else {
                                // Does it have a visible proxy to focus on instead?
                                tmp = tmpField.attr('validation-focus');
                                if( tmp ) {
                                    // This field is not visible, but referenes another field
                                    otherField = $('#' + tmp + ':visible');
                                    if( otherField.length ) {
                                        if(localData.debug) $log.log(localData.debugPrefix + "This field points to another field to focus on, so we can use it even thought it's not visible.");
                                        firstErrorField = otherField;
                                        break;
                                    }
                                } else if( tmpField.attr('froala') !== undefined ) {
                                    // This is a froala field and we haven't told it where to focus, so let's find the Froala editor, if possible
                                    tmpFroala = tmpField.prev('.fr-box');
                                    if( tmpFroala ) {
                                        firstErrorField = tmpFroala;
                                        if(localData.debug) $log.log(localData.debugPrefix + "Will focus on Froala field instead:", tmpFroala);
                                    }
                                }
                            }
                        }

                        if( firstErrorField === false ) {
                            // Didn't find an error field to focus on
                            if( errorFields.length ) {
                                // The field(s) in error are hidden
                                if(localData.debug) $log.log(localData.debugPrefix + "There are " + errorFields.length + " field(s) in error, but they are not visible.");
                                var firstErr        = errorFields.first();
                                var firstErrName    = firstErr.attr("name");
                                var firstErrId      = firstErr.attr("id");
                                var firstFor        = false; // The label (hopefully there is one)
                                var firstErrTitle   = 'hidden field'; // How we reference the first error for the user
                                if( firstErrId ) {
                                    firstFor = $("label[for='" + firstErrId + "']:not(.text-danger):first").text();
                                }

                                if( firstFor ) {
                                    firstErrTitle = firstFor;
                                } else if( firstErrName ) {
                                    firstErrTitle = firstErrName;
                                } else if( firstErrId ) {
                                    firstErrTitle = firstErrId;
                                }

                                // Let's log it, and tell the user about the first one
                                var error_message_to_log = "Validation Library: the form '" + attrs.name + "' failed to submit due to the hidden field '" + firstErrTitle + "' (id: " + firstErrId + ") being in error. The value is: '" + firstErr.val() + "'.";

                                if( firstErr && firstErr[0] && firstErr[0].name && localData.form && localData.form[firstErr[0].name] && localData.form[firstErr[0].name].$error ) {
                                    // We have an error object we can append to the error message
                                    error_message_to_log += " The Angular $error obect is: " + JSON.stringify(localData.form[firstErr[0].name].$error) + '.';
                                } else {
                                    error_message_to_log += " The Angular $error obect is unavailable because: (";
                                    if( !firstErr ) { error_message_to_log += " 'firstErr' not available;";}
                                    if( firstErr && !firstErr[0] ) { error_message_to_log += " 'firstErr[0]' not available;";}
                                    if( firstErr && firstErr[0] && !firstErr[0].name ) { error_message_to_log += " 'firstErr[0].name' not available;";}
                                    if( !localData.form ) { error_message_to_log += " 'localData.form' not available;";}
                                    if( localData.form && firstErr && firstErr[0] && firstErr[0].name && !localData.form[firstErr[0].name] ) { error_message_to_log += " 'localData.form[firstErr[0].name]' not available;";}
                                    if( localData.form && firstErr && firstErr[0] && firstErr[0].name && localData.form[firstErr[0].name] && !localData.form[firstErr[0].name].$error ) { error_message_to_log += " 'localData.form[firstErr[0].name].$error' not available;";}
                                    error_message_to_log += " ).";
                                }

                                if( elem.is(':visible') ) {
                                    error_message_to_log += " The form is visible, but the field is hidden. If the field is intentionally hidden, it may need the setting 'validation-focus' set to point to an alternate field to focus on.";
                                } else {
                                    error_message_to_log += " The form is also hidden, so this may be a side effect of some other action.";
                                }

                                global_helper.client_logger({
                                    error_message:  error_message_to_log,
                                    error_file:     window.location.href,
                                    error_line:     -1
                                }, 'hidden-field-in-error');

                                scope.ynConfirm({
                                    header:         '_VALIDATION_ERROR_FIELD_HIDDEN_TITLE_',
                                    headerParams:   [],
                                    content:        '_VALIDATION_ERROR_FIELD_HIDDEN_BODY_',
                                    contentParams:  [ firstErrTitle ],
                                    params:         {
                                        showCancel: false,
                                        isError:    true
                                    }
                                });

                            } else {
                                // All good, there are no fields in error to focus on
                                if(localData.debug) $log.log(localData.debugPrefix + "No fields in error. Focusing on the first field instead.");
                            }
                        } else {
                            // We have a error so, focus on that one instead
                            if(localData.debug) $log.log(localData.debugPrefix + 'Focusing on the first field in error: ', firstErrorField);
                            focusFirst      = false;
                            focusFirstError = true;
                        }
                    }

                    setAllDirtyIterator(localData.form, localData.formDom, focusFirst, focusFirstError);
                };

                /*
                 * setAllDirtyIterator:
                 *      Iterate over fields.
                 *      @param elem - either the form, sub-form, or an individual element.
                 *      @param elemDom - for the form, it's the DOM element, for the field, it's the DOM of the field itself.
                 */
                var setAllDirtyIterator = function(elem, elemDom, focusFirst, focusFirstError) {
                    var field, // Stores the Dom node of the element
                        tmp,
                        otherField;
                    
                    elem.$setDirty();
                    // The form doesn't have touched, but the form fields do.
                    if( elem.$setTouched === undefined ) {
                        if(localData.debug) $log.log(localData.debugPrefix + 'setting the form dirty:', elem.$name);
                        if(localData.debug && focusFirst) $log.log(localData.debugPrefix + 'focusing on the first field.');
                        if(localData.debug && focusFirstError) $log.log(localData.debugPrefix + 'focusing on the first ERROR field.');

                        // Set the fields dirty
                        ng.forEach(elem, function(element, key) {
                            if( key.indexOf('$') !== 0 && !global_helper.blank(element) && !global_helper.blank(element.$name) ) {
                                //  It's not an internal Angular attribute, so mark it dirty.
                                field = $("[name='" + element.$name + "']:first", elemDom);
                                setAllDirtyIterator(element, field, focusFirst, focusFirstError);
                            }
                        });

                    } else {

                        /* Since we are setting all dirty, the user has submitted the form. We are going to check
                         * to make sure that if the field is a Froala editor, that it's in design view. Otherwise
                         * errors don't show, and the user's changes might not get saved because the model isn't
                         * updated unless in design view.
                         *
                         * This is kind of a hack putting it here, but this guarantees we are hooked into the save method.
                         */
                        if( elemDom.attr('froala') !== undefined ) {
                            validationHelper.checkFroala(elemDom, localData.debug, localData.debugPrefix);
                        }

                        // Found an individual field
                        if(localData.debug) $log.log(localData.debugPrefix + 'setting individual field dirty:', elem.$name);
                        elem.$setTouched();

                        if( !localData.formFieldFocused && ( focusFirst || focusFirstError) ) {
                            if(localData.debug) $log.log(localData.debugPrefix + "Haven't focused on a field yet, but we need to. (localData.formFieldFocused:", localData.formFieldFocused, ', focusFirst:', focusFirst, ', focusFirstError:', focusFirstError, ')');
                            // We haven't focused on a field yet, let's see if this is the one
                            if( focusFirst || elem.$invalid ) {
                                // Either this is the first field, or the first invalid field (or both!)
                                elem.showError              = true;
                                localData.formFieldFocused  = true;

                                tmp = elemDom.attr('validation-focus');
                                if( tmp ) {
                                    otherField = tmp;
                                    if(localData.debug) $log.log(localData.debugPrefix + "Will focus on other field instead:", otherField);
                                } else if( elemDom.attr('froala') !== undefined ) {
                                    // This is a froala field and we haven't told it where to focus, so let's find the Froala editor, if possible
                                    tmp = elemDom.prev('.fr-box');
                                    if( tmp ) {
                                        otherField = tmp;
                                        if(localData.debug) $log.log(localData.debugPrefix + "Will focus on Froala field instead:", otherField);
                                    }
                                }

                                if( otherField ) {
                                    // Run the blur function on the hidden field so it's errors show up.
                                    elemDom.blur();
                                    // Now focus on the visible field
                                    if(localData.debug) $log.log(localData.debugPrefix + "Focusing on:", otherField);
                                    focusOther(localData.form, otherField);
                                } else {
                                    // It's visible so just go straight there
                                    if(localData.debug) $log.log(localData.debugPrefix + "Focusing on:", elemDom);
                                    elemDom.focus();
                                    elemDom.addClass('has-error');
                                    elemDom.on('blur', function() {
                                        if (elemDom.hasClass('ng-invalid')) {
                                            elemDom.addClass('has-error');
                                        } else {
                                            elemDom.removeClass('has-error');
                                        }
                                    });
                                }
                            }
                        } else {
                            if(localData.debug) $log.log(localData.debugPrefix + 'No need to focus on a field. (localData.formFieldFocused:', localData.formFieldFocused, ', focusFirst:', focusFirst, ', focusFirstError:', focusFirstError, ')');
                        }
                    }

                    if( !localData.prefillDataChecked ) {
                        // It will have been checked now
                        localData.prefillDataChecked = true;
                    }
                };

                // Add the form actions
                elem.on('reset', function(evt) {
                    if(localData.debug) $log.log(localData.debugPrefix + 'reset called.');

                    // Also make sure the form is pristine
                    localData.form.$setPristine();
                    localData.form.$setUntouched();

                    // Keep the form from resetting normally
                    evt.stopPropagation();
                    evt.preventDefault();
                });

                elem.on('submit', function(evt) {
                    if(localData.debug) $log.log(localData.debugPrefix + 'submit called.');
                    var submitTime = new Date();
                    
                    if( localData.lastSubmitTime && submitTime - localData.lastSubmitTime < 500 ) {
                        // Stop this submit
                        if(localData.debug) $log.log(localData.debugPrefix + 'submit cancelled because it\'s so close to the last submit it\'s probably a double clicker.');
                        return false;
                    } else {
                        if( localData.prefillDataChecked ) {
                            if(localData.debug) $log.log(localData.debugPrefix + 'prefill check done.');
                            // The submit was fine, log the submit time
                            localData.lastSubmitTime = submitTime;

                            // submit the form normally
                            if( localData.form.$valid ) {
                                if(localData.debug) $log.log(localData.debugPrefix + 'Form is valid.');
                                if( global_helper.blank( attrs.validationSubmitting ) ) {
                                    if(localData.debug) $log.log(localData.debugPrefix + 'No validation submitting variable set, skipping...');
                                } else {
                                    $timeout(function() {
                                        scope[ attrs.validationSubmitting ] = true;
                                        if(localData.debug) $log.log(localData.debugPrefix + 'Setting the validation submitting variable to true:', attrs.validationSubmitting);
                                    });
                                }
                                // Do we run the after validation function
                                if( localData.action === true ) {
                                    if(localData.debug) $log.log(localData.debugPrefix + 'No validation function, submitting the form normally.');
                                } else {
                                    // Keep the form from submitting normally
                                    if(localData.debug) $log.log(localData.debugPrefix + 'We have a validation function, attempting to run: ' + attrs.vspotValidation);
                                    evt.stopPropagation();
                                    evt.preventDefault();

                                    // Run the submit function
                                    // But is it in this scope or the parent scope?
                                    try {
                                        // Try the current scope
                                        localData.action(evt, localData.form);
                                    } catch(err) {
                                        $log.error("Trying to run function '" + localData.action + "' received an error:", err);
                                    }
                                }
                            } else {
                                if(localData.debug) $log.log(localData.debugPrefix + 'Form is NOT valid.');
                                // Keep the form from submitting normally
                                evt.stopPropagation();
                                evt.preventDefault();

                                // Iterate over the form and set all the fields to be dirty
                                setAllDirty(true);
                            }
                        } else {
                            // We're going to run the prefill check, so we don't want to log the submit time yet
                            if(localData.debug) $log.log(localData.debugPrefix + 'prefill check NOT done. Will set all dirty and resubmit.');
                            // Keep the form from submitting normally
                            evt.stopPropagation();
                            evt.preventDefault();

                            // Iterate over the form and set all the fields to be dirty
                            setAllDirty(false);

                            // Try submitting the form again
                            localData.formDom.submit();
                        }
                    }
                });
            }
        };
     }]);
});
